import { Typography } from '@chronosphereio/chrono-ui';
import type { ReactNode } from 'react';

export interface QueryEditorOptionSummaryItemProps {
  label: string;
  value: ReactNode;
}

/**
 * Renders a single "label: value" pair for use inside the `summary` prop of
 * `QueryEditor.OptionsCollapse`. Pairs are separated by consistent inline
 * spacing when composed side-by-side.
 */
export function QueryEditorOptionSummaryItem({ label, value }: QueryEditorOptionSummaryItemProps) {
  return (
    <Typography variant="body2" component="span" color="text.legacySecondary" sx={{ mr: 2 }}>
      {label}: {value}
    </Typography>
  );
}
